import "../Styles/Projects.css";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import CodeIcon from "@mui/icons-material/Code";
import OpenInBrowserIcon from "@mui/icons-material/OpenInBrowser";
import { project } from "../utils/Projects";



export const Projects = () => {
  const handleClick = (url) => {
    window.open(url);
  };

  return (
    <div className="projects" id="projects">
      <p className="projects-header">Projects</p>
      <div className="projects-content">
        {project.map((el) => {
          return (
            <Card sx={{ maxWidth: 345 }} className="project-card">
              <CardMedia
                component="img"
                height="140"
                image={el.image}
                alt="green iguana"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="div">
                  {el.title}
                </Typography>
                <Typography gutterBottom  component="div">
                  {el.tech_stack}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {el.description}
                </Typography>
              </CardContent>
              <CardActions>
                <Button
                  variant="outlined"
                  endIcon={<CodeIcon />}
                  color="inherit"
                  size="small"
                  onClick={() => handleClick(el.github)}
                >
                  Code
                </Button>
                <Button
                  variant="outlined"
                  endIcon={<OpenInBrowserIcon />}
                  color="inherit"
                  size="small"
                  onClick={() => handleClick(el.live)}
                >
                  Live
                </Button>
              </CardActions>
            </Card>
          );
        })}
      </div>
    </div>
  );
};
